import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { PropType } from "vue";
import LiveBaseImage from "@/components/live_video/LiveBaseImage.vue";
import LiveBaseVideo from "@/components/live_video/LiveBaseVideo.vue";
import { useLiveImageSetting } from "@/composables/stream";


export default /*#__PURE__*/_defineComponent({
  __name: 'LiveBase',
  props: {
  cameraId: {
    type: String,
    required: true,
  },
  noSrcMessage: {
    type: String as PropType<string | null>,
    required: false,
  },
  addRightSpaceToControlBar: {
    type: Boolean,
    required: false,
  },
},
  setup(__props) {

const { useLiveImage } = useLiveImageSetting();

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_unref(useLiveImage))
    ? (_openBlock(), _createBlock(LiveBaseImage, {
        key: 0,
        cameraId: props.cameraId,
        noSrcMessage: __props.noSrcMessage,
        addRightSpaceToControlBar: __props.addRightSpaceToControlBar
      }, null, 8, ["cameraId", "noSrcMessage", "addRightSpaceToControlBar"]))
    : (_openBlock(), _createBlock(LiveBaseVideo, {
        key: 1,
        cameraId: props.cameraId,
        noSrcMessage: __props.noSrcMessage,
        addRightSpaceToControlBar: __props.addRightSpaceToControlBar
      }, null, 8, ["cameraId", "noSrcMessage", "addRightSpaceToControlBar"]))
}
}

})